import React from "react"
import Heading from "./Heading"
import { Link } from "gatsby"

export default function Infoblock({ heading }) {
  return (
    <section className="bg-theme my-5 py-4">
      <div className="container">
        <Heading title={heading} />
        <div className="row">
          <div className="col-10 col-sm-8 mx-auto text-center">
            <p className="lead text-white mb-4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Pellentesque lacinia dolor sit amet magna varius, at convallis
              erat dignissim. Maecenas et consequat nibh. Phasellus sodales
              metus pharetra elit viverra, tristique vulputate ipsum pretium.
              Curabitur placerat nec dolor vel dapibus. Vestibulum a convallis
              elit. Cras nunc nibh, feugiat in ornare ac, pharetra vitae ex.
              Quisque tincidunt, augue sit amet gravida placerat.
            </p>
            <Link to="/about/">
              <button className="btn btn-warning btn-lg">{heading}</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
